import { Route, AppId, createPageRoute } from '@lumapps/router';

export const searchSettingsRoute: Route = createPageRoute({
    slug: 'search-settings/results-page',
    id: 'search-settings-results-page',
    appId: AppId.backOffice,
});

export const searchSettingsConfigRoute: Route = createPageRoute({
    slug: 'search-settings/results-page/:id',
    id: 'search-settings-results-page-details',
    appId: AppId.backOffice,
});

export const searchSettings = (): Route => searchSettingsRoute;
export const searchSettingsConfig = (id: string): Route => ({
    ...searchSettingsConfigRoute,
    params: {
        id,
    },
});
